// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"65603a0c","132":"276c85ad","173":"56d89df1","365":"059ad595","441":"b978b87c","458":"ca23abbb","469":"274b1c0f","636":"51369b0d","780":"efe8e06c"}[chunkId] + ".chunk.js";
};